/**
 * Injects CSS into an ElevenLabs widget's shadow root to hide branding.
 * Polls until the shadow root is available, then injects the style.
 */
export function hideElevenLabsBranding(element: HTMLElement): () => void {
  const css = `
    .powered-by, [class*="powered"], a[href*="elevenlabs"] {
      display: none !important;
    }
  `;

  let attempts = 0;
  const maxAttempts = 50; // 5 seconds

  const interval = setInterval(() => {
    attempts++;
    const shadow = element.shadowRoot;
    if (shadow) {
      const style = document.createElement('style');
      style.textContent = css;
      shadow.appendChild(style);
      clearInterval(interval);
    } else if (attempts >= maxAttempts) {
      clearInterval(interval);
    }
  }, 100);

  return () => clearInterval(interval);
}
